// Stepper for a −/count/+ pair. Both buttons are 44px and labelled in words, so
// a screen reader says "Add one Silkie" rather than "plus".

import { button, h } from '../dom';
import { t } from '../../i18n';

export interface StepperOptions {
  /** i18n keys for the two labels, e.g. `buy.addBreed`. */
  addLabelKey: string;
  removeLabelKey: string;
  /**
   * What is being counted, for the labels. Without it every breed's stepper
   * announced the same un-substituted "Add one {breed}" — four identical
   * buttons to a screen reader on the buy screen.
   */
  name: string;
  value: number;
  min?: number;
  max: number;
  onChange: (next: number) => void;
}

export function stepper(options: StepperOptions): HTMLElement {
  const min = options.min ?? 0;
  const remove = button({
    class: 'cf-stepper__btn',
    text: '−',
    attrs: { 'aria-label': t(options.removeLabelKey, { breed: options.name }) },
    on: { click: () => options.onChange(Math.max(min, options.value - 1)) },
  });
  const add = button({
    class: 'cf-stepper__btn cf-stepper__btn--add',
    text: '+',
    attrs: { 'aria-label': t(options.addLabelKey, { breed: options.name }) },
    on: { click: () => options.onChange(Math.min(options.max, options.value + 1)) },
  });
  remove.disabled = options.value <= min;
  add.disabled = options.value >= options.max;
  return h(
    'div',
    { class: 'cf-stepper' },
    remove,
    h('span', { class: 'cf-stepper__count cf-num', text: String(options.value) }),
    add,
  );
}
